import { MultiSelectCategory } from './MultiSelectCategory'
import { withMultiSelectCategory } from './withMultiSelectCategory'

const ConnectedMultiSelectCategory =
  withMultiSelectCategory(MultiSelectCategory)

export { ConnectedMultiSelectCategory as MultiSelectCategory }
